import { Injectable } from '@angular/core';
import { first, map } from 'rxjs/operators';
import { Category } from '../models/category';
import { FwHttpService } from './fw-http.service';

@Injectable()
export class CategoryService {

  static prefix = 'categories';
  static projectId = 6;

  constructor(private http: FwHttpService) { }

  public byId(id: number) {
    return this.http.get<Category>(`${CategoryService.prefix}/view/${id}.json`);
  }

  public children(id: number) {
    return this.http.get<Category>(`${CategoryService.prefix}/viewChildren/${id}.json`);
  }

  public allByProjectId(projectId: number) {
    return this.http.get<Category[]>(`${CategoryService.prefix}/index/${projectId}.json`);
  }

  public current() {
    return this.http.get<Category>(`${CategoryService.prefix}/current.json`)
      .pipe(map(category => category['category']))
  }

  public currentYear() {
    return this.http.get<Category[]>(`${CategoryService.prefix}/currentYear.json`)
      .pipe(map(categories => categories['categories']))
  }

  async fillParents(cat: Category) {
    let catOut: Category = cat;
    if (cat.parent_id) {
      catOut.parent = Object.assign(new Category(), await this.byId(cat.parent_id)
        .pipe(
          map(cat => cat.category),
          first(),
        )
        .toPromise()
      );
      this.fillParents(catOut.parent);
    } else {
      catOut.parent = undefined;
    }
    return catOut;
  }
}
